import { useState } from 'react';
import { styled } from '@mui/material/styles';
import CompanySearchWidget from './_companySearchWidget';
import CompanyReportWithMenus from 'kosmos/components/companyReport/CompanyReportWithMenus';
import CombinedCompanyReportWithMenus from 'kosmos/components/combinedCompanyReport/CompanyReportWithMenus';
import OrganisationOutOfCreditNotice from 'kosmos/components/OrganisationOutOfCreditNotice';
import { GetSgReportById } from 'services/kosmosReport';

const PREFIX = 'TfpHomePage';
const classes = {
  hidden: `${PREFIX}-hidden`,
  report: `${PREFIX}-report`,
  notice: `${PREFIX}-notice`,
};

const Root = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  [`& .${classes.hidden}`]: {
    display: 'none'
  },
  [`& .${classes.report}`]: {
  },
  [`& .${classes.notice}`]: {
    margin: theme.spacing(5),
  },
}));

export default function TfpHomePage(): JSX.Element {
  const [selectedCompanyId, setSelectedCompanyId] = useState<string>('');
  const [selectedSgCompanyId, setSelectedSgCompanyId] = useState<string>('');

  const [showNotice, setShowNotice] = useState(false);

  const renderReport = () => {
    return (
      <CompanyReportWithMenus
        id={selectedCompanyId}
        onBack={() => setSelectedCompanyId('')}
      />
    );
  };

  const renderCombinedReport = () => {
    return (
      <CombinedCompanyReportWithMenus
        id={selectedSgCompanyId}
        onBack={() => setSelectedSgCompanyId('')}
        onFetchReport={GetSgReportById}
      />
    );
  };

  const onScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const handleShowOutOfCreditsNotice = () => {
    setShowNotice(true);
    onScrollToTop();
  };

  return (
    <Root>
      <div id="out-of-credit"></div>
      {showNotice && (
        <div className={classes.notice}>
          <OrganisationOutOfCreditNotice showNotice={showNotice} />
        </div>
      )}
      <div className={(selectedCompanyId || selectedSgCompanyId) ? classes.hidden : ''}>
        <CompanySearchWidget
          title=""
          onShowOutOfCreditsNotice={handleShowOutOfCreditsNotice}
          onSelectCompany={setSelectedCompanyId}
          onSelectSgCompany={setSelectedSgCompanyId}
        />
      </div>

      {selectedCompanyId && (
        <div className={classes.report}>
          {renderReport()}
        </div>
      )}

      {selectedSgCompanyId && (
        <div className={classes.report}>
          {renderCombinedReport()}
        </div>
      )}
    </Root>
  );
}
